module.exports = __webpack_public_path__ + "static/Kracks_main-70e7e7a855045db882fb0ee8c4c400ef.mp4";